export default __webpack_public_path__ + "static/media/main-slide-01.5f967627.png";